import { createContext, useContext } from 'react';
import { TenpoResponseDto } from 'api/generated/openapi';

export const TenpoContext = createContext<TenpoResponseDto | null>(null);

export const useTenpo = () => {
  const context = useContext(TenpoContext);
  if (!context) throw new Error('no tenpo context error');
  return context;
};
